// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionDeeplinkController from "./accordion_deeplink_controller"
import AutoscrollController from "./autoscroll_controller"
import ChatController from "./chat_controller"
import CheckboxGateController from "./checkbox_gate_controller"
import CopyTextController from "./copy_text_controller"
import DocsScrollspyController from "./docs_scrollspy_controller"
import DocsSearchController from "./docs_search_controller"
import EvaluateActionsController from "./evaluate_actions_controller"
import ExamplePromptController from "./example_prompt_controller"
import FileAccumulatorController from "./file_accumulator_controller"
import FineTuneModelController from "./fine_tune_model_controller"
import GovernanceFiltersController from "./governance_filters_controller"
import HelloController from "./hello_controller"
import ModelMultiSelectController from "./model_multi_select_controller"
import SubmitLoadingController from "./submit_loading_controller"

application.register("accordion-deeplink", AccordionDeeplinkController)
application.register("autoscroll", AutoscrollController)
application.register("chat", ChatController)
application.register("checkbox-gate", CheckboxGateController)
application.register("copy-text", CopyTextController)
application.register("docs-scrollspy", DocsScrollspyController)
application.register("docs-search", DocsSearchController)
application.register("evaluate-actions", EvaluateActionsController)
application.register("example-prompt", ExamplePromptController)
application.register("file-accumulator", FileAccumulatorController)
application.register("fine-tune-model", FineTuneModelController)
application.register("governance-filters", GovernanceFiltersController)
application.register("hello", HelloController)
application.register("model-multi-select", ModelMultiSelectController)
application.register("submit-loading", SubmitLoadingController)
